import React, { Component } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';

import './ModalRichTextEditor.css';
import ParadigmaEditor from '../../components/ParadigmaEditor/ParadigmaEditor';

class ModalRichTextEditor extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            __html: ''
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value) {
            this.setState({ __html: this.props.value });
        }
    }

    onChange = editorState => this.setState({ editorState });
    openModal = _ => this.setState({ open: !this.props.disabled });
    closeModal = _ => this.setState({ open: false });

    submit = () => {
        const { __html } = this.state;

        this.props.onSubmit(__html);
        this.closeModal();
    }

    createMarkup = () => {
        return {
            __html: this.state.__html
        };
    }

    render() {
        const { disabled } = this.props;
        return (
            <div>
                <a
                    className={'form-control riched-text-preview ui-rich-text-preview ui-rich-text-preview-large' + (disabled ? ' disabled' : '')}
                    dangerouslySetInnerHTML={this.createMarkup()}
                    onClick={this.openModal}
                />
                <Modal
                    size="lg"
                    isOpen={this.state.open}
                    toggle={this.closeModal}
                    backdrop={false}
                    className="ui-paradigma-modal ui-paradigma-modal-wide"
                >
                    <ModalHeader>Descripción Web</ModalHeader>
                    <ModalBody>
                        <section className="ui-modal-section">
                            <p className="ui-section-label">Contenido</p>
                            <ParadigmaEditor
                                value={this.state.__html}
                                onChange={__html => this.setState({ __html })}
                            />
                        </section>
                    </ModalBody>
                    <ModalFooter>
                        <Button onClick={this.closeModal}>Cancelar</Button>
                        <Button onClick={this.submit} color="success">Aceptar</Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}

export default ModalRichTextEditor;



// WEBPACK FOOTER //
// ./src/views/Loteos/ModalRichTextEditor.js